<template>
  <div class="allCampaign">
    <div class="empty" v-if="loading">
        <adx-empty />
    </div>
    <div class="empty" v-else-if="loading">
        <adx-loading-primary />
    </div>
    <div v-else>
    <div class="allCampaign__header">
      <div class="allCampaign__header__left">
        <div class="allCampaign__header__left__status">
          <adx-dropdown-search @selected="selectedLocation" :list="locations" labelButton="Location" :selected-value="selectedLocationValue"/>
        </div>
        <div class="allCampaign__header__left__status">
          <adx-dropdown-list :labelButton="selectedStatusLabel?selectedStatusLabel:`Status`" :valueDisplay="selectedStatusValue" :list="statusList" @selected="selectStatus" />
        </div>
        <div v-if="filtered" class="reset">
          <button class="btn-regular primary" @click="resetFilter">Reset</button>
        </div>
      </div>
      <div class="allCampaign__header__right">
        <p>Sort by :</p>
        <div>
          <adx-dropdown-sort  :labelButton="`All Filter`"
           :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
        </div>
      </div>
    </div>
    <div class="allCampaign__search">
        <i class="adx-ic_search"></i>
        <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
      </div>
    <!-- allCampaign -->
    <div class="allCampaign__content">
      <div>
        <table>
          <thead class="none">
            <tr>
              <td class="header subhead">Campaign</td>
              <td class="header subhead">Status</td>
              <td class="header subhead">Period</td>
               <td class="header subhead"></td>
            </tr>
          </thead>
          <tbody v-if="!isLoading && !isEmpty">
            <tr v-for="(item, index) in items" :key="index" class="content">
              <td class="ID subhead">
               <div>{{item.title}}</div>
               <div class="subtitle">{{item.location_count}} Locations</div>
              </td>
              <td class="period subhead" > 
                <div class="active" v-if="item.status == 'active'">Active</div>
                <div class="color-orange" v-else-if="item.status == 'upcoming'"> Upcoming</div>
                <div class="expired" v-else>Expired</div>
              </td>
              <td class="position active subhead">
                <div>{{ displayPeriod(item.start, item.end) }} </div></td>
              <td><div class="menuExpansion"><menu-expansion  @selected="selected($event, item)" :lists="menuList" />
              </div></td>
            </tr>
          </tbody>
        </table>
        <!-- Pagination -->
        <div class="pagination" v-if="!isLoading && !isEmpty"><adx-pagination :selectedPage="selectedPage" 
        :maxPage="maxPage" @change-page="selectPage"/></div>
        <!-- Loading State -->
        <div class="loadingState"><adx-loading v-if="isLoading" slot="loading" /></div>
      </div>
        <!-- Empty State -->
        <div class="emptyState"><adx-empty-selection v-if="isEmpty && !isLoading" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import DropdownSort from '@/components/Form/SelectDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import types from '@/lib/types'
import Empty from '@/components/NotFound/Measurement'
import EmptySelection from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'
import LoadingPrimary from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'
import DropdownSearch from '@/components/Dropdown/SearchDropdown'
import MenuExpansion from '@/components/MenuExpansion'
import lib from '@/lib/util'

// Api
import api from '@/api'
import { apiV2 } from '@/api/urls'
import * as validationLib from '@/lib/validation/'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex';
const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-admin-measurement',
  components: {
    'adx-dropdown-list': ListDropdown,
    'adx-dropdown-sort': DropdownSort,
    'adx-loading-primary': LoadingPrimary,
    'adx-empty': Empty,
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'adx-dropdown-search': DropdownSearch,
    'menu-expansion': MenuExpansion,
  },
    props: {
  },
  data() {
    return {
      loading: false,
      selectAll: false,
      isOpen: false,
      sort: [
        {
          'id': 0,
          'label': 'Last Added',
          'value': 'last_added'
        },
        {
          'id': 1,
          'label': 'First Added',
          'value': 'first_added'
        },
        {
          'id': 2,
          'label': 'Name',
          'value': 'name'
        },
      ],
      selectedSortValue: 'last_added',
      searchBoxValue: '',
      selectedRow: null,
      isInit: true,
      isLoading: false,
      isLoadingDelete: false,
      isEmpty: false,
      details: [],
      selectedPage: 1,
      maxPage: 0,
      items: [],
      all_data: [],
      selectedStatusValue: null,
      selectedStatusLabel: null,
      selectedLocationValue: null,
      locations:[],
      statusList: [
        {
          id: 0,
          label: 'All',
          value: null
        },
        {
          id: 1,
          label: 'Active',
          value: "active"
        },
        {
          id: 2,
          label: 'Expired',
          value: "expired"
        },
      ],
      menuList: [
        {
          "id": 0,
          "name": "Edit Measurement",
          "value": "editmeasurement"
        },
        {
          "id": 1,
          "name": "Input Report",
          "value": "inputreport"
        },
      ],
    }
  },
  computed: {
    filtered: function() {
      let filtered = false
      if (this.selectedStatusLabel || this.selectedLocationValue) {
        filtered = true
      }
      return filtered
    },
    getFilterParams: function () {
      const params = {
        sort_by: this.selectedSortValue || undefined,
        search: this.searchBoxValue || undefined,
        status: this.selectedStatusValue || undefined,
        location: this.selectedLocationValue || undefined
      }
      return params
    },
    ...mapGetters({
      user: 'account',
    })
  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.$nextTick(function () {
        this.selectedPage = 1
        this.initialLoad()
      })
    }, 500),
    selectedStatusValue: function() {
      this.$nextTick(() => {
        this.initialLoad()
      })
    },
    selectedLocationValue: function() {
      this.$nextTick(() => {
        this.initialLoad()
      })
    },
    selectedSortValue: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.selectedPage = 1
        this.selectedSortValue = newValue
        this.initialLoad()
      }
    }
  },
  beforeCreate() {

  },
  created() {
    this.initialLoad()
  },
  beforeMount() {

  },
  mounted() {
    if (this.$route.query.page) {
      this.selectedPage = this.$route.query.page
    }
    this.initialLoad()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    initialLoad(isInit = null) {
      (async () => {
        this.isLoading = true
        this.isEmpty = false
        let params = {
          page: this.selectedPage,
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.measurementcampaignReport, { needToken: true, params })
        if (!data.count) {
          this.isEmpty = true
        }
        this.items = data.results
        this.items
        this.all_data = data.results
        this.maxPage = data.max_page

        this.getFilter()

        this.$data.isLoading = false
      })();
    },
    selectPage(item) {
      this.selectedPage = item
      this.initialLoad()
    },
    selectStatus(item) {
      this.selectedStatusLabel = item.label
      this.selectedStatusValue = item.value
    },
    goToAddNew() {
      this.$router.push({name: 'addnew'})
    },
    getFilter () {
      (async () => {
        const { data } = await api.get(apiV2.deviceFilters)
        this.locations = data.cities
      })();
    },
    selectedLocation(item){
      this.selectedLocationValue = item.id.toString()
    },
    resetFilter() {
      this.selectedLocationValue = null
      this.selectedStatusLabel = null
      this.selectedStatusValue = null
    },
    selected(e, item) {
      if(e.value == 'inputreport'){
        this.$router.push({ name: 'traffic', query: { id: item.campaign_report_id, campaign_id:item.id } })
      } else {
        this.$router.push({ name: 'edit', query: { id: item.campaign_report_id } })
      }
    },

    displayPeriod(start, end) {
      let startDate = moment(start, 'YYYY-MM-DD')
      let endDate = moment(end, 'YYYY-MM-DD')
      if (startDate.year() == endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      } else if (startDate.year() < endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      }
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>